import React from 'react'
import PropTypes from 'prop-types'
import { trackGtmEvent } from '../../util/tracking'
import $ from 'jquery'
import './styles.scss'
import l10n from '../../shared/l10n'

const {
  common: { requestnow },
  single: { sMonth },
} = l10n

const KoronaTarife = ({ tariffs }) => {
  const requestTariff = tariff => {
    const form_id = 8
    const el_id = 'gform_' + form_id
    const $gform = $('#' + el_id)
    // const $gform_footer = $gform.find('#gform_next_button_' + form_id + '_1')
    if ($gform.length) {
      const $tariff_type = $('#input_' + form_id + '_1')
      var $form_type_val = ''
      if (tariff.tariftypeform) {
        $form_type_val = tariff.tariftypeform
      } else {
        $form_type_val = tariff.title
      }
      $tariff_type.val($form_type_val).change()
      $tariff_type[0].sumo.reload()

      const yOffset = -100
      const element = document.getElementById(el_id)
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })

      trackGtmEvent('llplusInteractions', {
        llplusInteraction: 'request-now',
        llplusTarif: tariff.title,
      })
      // if (window.location.pathname === '/bestellen/korona-kasse/') {
      //   trackGtmEvent('llplus_korona_eventTracking', {
      //     llplus_interaction: 'configuration',
      //     llplus_functionality: tariff.title,
      //   })
      // }
    }
  }

  return (
    <div className={`dhsv_korona_tarife`}>
      <div className="row">
        {tariffs.map((tariff, i) => (
          <div key={i} className="col-12 col-md-6 col-lg-4">
            <div className="dhsv_korona_tarife_tarif">
              <div>
                <p className="big red">{tariff.title}</p>
              </div>
              <div>
                <p>{tariff.runtime}</p>
                <p className="cost">
                  <span className="red">{tariff.cost_per_month}</span>
                  <span>/{sMonth}</span>
                </p>
              </div>
              <div>
                <ul>
                  {tariff.benefits.map((benefit, i) => (
                    <li
                      key={i}
                      className={`benefit-${benefit.checked ? 'incl' : 'excl'}`}
                    >
                      <i
                        className={`btr bt-${
                          benefit.checked ? 'check' : 'times'
                        }`}
                      />
                      <span>{benefit.title}</span>
                    </li>
                  ))}
                </ul>
              </div>
              {tariff.sub_title && (
                <div>
                  <p className="big">{tariff.sub_title}</p>
                </div>
              )}
              <div>
                {tariff.text && <p className="small">{tariff.text}</p>}
                <button
                  onClick={() => {
                    requestTariff(tariff)
                  }}
                  className="button whisper"
                >
                  {requestnow}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

KoronaTarife.propTypes = {
  tariffs: PropTypes.array,
  isMD: PropTypes.bool,
}

export default KoronaTarife
